// extracted by mini-css-extract-plugin
export default {"root":"style_root__B8EN5","btnWhy":"style_btnWhy__ABKIE"};